<global-modal>
  <header>
    <a mat-icon-button (click)="close()">
      <mat-icon svgIcon="arrow_back"></mat-icon>
    </a>
    <h1>DATA PRIVACY POLICY</h1>
  </header>

  <auth-privacy-policy-text dialog></auth-privacy-policy-text>
</global-modal>
